import { render, staticRenderFns } from "./EventDetailsModal.vue?vue&type=template&id=c4454838&scoped=true&"
import script from "./EventDetailsModal.vue?vue&type=script&lang=js&"
export * from "./EventDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./EventDetailsModal.vue?vue&type=style&index=0&id=c4454838&lang=scss&scoped=true&"
import style1 from "./EventDetailsModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4454838",
  null
  
)

export default component.exports